import CustomPage from "@/views/correspondence/components/list";
export default {
  name: "correspondence-send",
  components: {
    CustomPage: CustomPage
  }
};